// https://github.com/giantcz/gia
// Add import to js/components
import Component from 'gia/Component'
import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default'

import Swiper, { Navigation } from 'swiper';
Swiper.use([Navigation]);

export default class VenueComponent extends Component {

  constructor(element) {
    super(element);
    this.ref = {
      wrapper: null,
      item: [],

      //swiper els
      pswpThumbnails: null,
      pswpThumbnailsWrapper: null,
      pswpThumbnailsNext: null,
      pswpThumbnailsPrev: null,
      
      //pswp els
      pswp: null,
      photos: [],

      galleryOpener: null,
      data: null
    }
    this.gallery = null;
    this.swiper = null;
    this.photoswipe = null;

    this.items = this.getInitialProps();
  }



  getInitialProps() {
    let data = {}
    try {
      data = JSON.parse(this.ref.data.innerText)
    }
    catch (e) {}
    return data
  }

  mount() { 
    const vm = this;
      if(this.items.length) {
          // swiper & photoswipe init
          vm.initSwiper();
          vm.ref.galleryOpener.addEventListener('click', this.openPhotoSwipe(0).bind(this))
      }
    
  }

  initSwiper() {
    const vm = this;
    //swiper
    const swiperConfig = {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 0,
      threshold: 25,
      loop: false,
      navigation: {
        nextEl: vm.ref.pswpThumbnailsNext,
        prevEl: vm.ref.pswpThumbnailsPrev
      },
    }
    this.swiper = new Swiper(this.ref.pswpThumbnails, swiperConfig);
}

resetSwiper() {
  this.swiper.destroy();
  this.initSwiper();
}

//takes index to open to specific image, else opens to first image in array
openPhotoSwipe(index = null) {

    return function () {
    const vm = this;
    
    // possible options here: https://photoswipe.com/documentation/options.html
    const options = {
      timeToIdle: 9e9,
      timeToIdleOutside: 9e9,
      closeEl: true,
      bgOpacity: 0.85,
      captionEl: false,
      fullscreenEl: true,
      zoomEl: true,
      shareEl: false,
      counterEl: true,
      arrowEl: true,
      preloaderEl: true,
      history: false,
      closeOnScroll: false
    };
    
    if (index) {
      options.index = parseInt(index, 10);
    }
    this.swiper.slideToLoop(parseInt(index, 10));

    // Initializes PhotoSwipe
    console.log('this.items', this.items);
    console.log('this.ref.pswp', this.ref.pswp);
    this.gallery = new PhotoSwipe(this.ref.pswp, PhotoSwipeUI_Default, this.items, options);
    this.gallery.init();

    this.gallery.listen('close', () => {
      this.element.classList.remove('pswp-open');
      this.resetSwiper();
    });
    
    this.gallery.listen('afterChange', function () {
      vm.swiper.slideToLoop(this.getCurrentIndex());
    });

    this.swiper.on('slideChange', function () {
      if (vm.gallery && this.realIndex != vm.gallery.getCurrentIndex()) {
        vm.gallery.goTo(parseInt(this.realIndex, 10));
      }
    });
    
    const thumbnails = this.swiper.slides;
    for (const thumb of thumbnails) {
      thumb.addEventListener('click', function () {
        const ix = this.dataset.index;
        //move swiper to index
        vm.swiper.slideToLoop(ix);
        // //move pswp to index
        vm.gallery.goTo(parseInt(ix, 10));
      })
    }
    
    
    //animate thumbnails in
    vm.element.classList.add('pswp-open');
  }
}
  
}
